var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 18,
    viewBox: "0 0 150 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_2890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.1054 4.1393V0.540039H90.2276V17.3981H86.1054V4.1393ZM67.9553 0.540039H83.8597V4.17006H76.3843V17.4289H72.2929V4.17006H67.9553V0.540039ZM150 0.540039V4.17006H142.525V17.4289H138.433V4.17006H134.096V0.540039H150ZM0 0.540039H17.8425V4.17006H4.12223V7.76933H15.8121V11.3993H4.12223V17.3981H0V0.540039ZM115.207 0.540039H131.819V4.17006H119.329V7.18483H129.573V10.8149H119.329V13.8296H132.034V17.4596H115.207V0.540039ZM112.039 5.30829V17.3981H107.916V5.30829C107.916 4.66227 107.424 4.17006 106.778 4.17006H97.5492V17.4289H93.427V0.540039H107.27C109.885 0.540039 112.039 2.69344 112.039 5.30829ZM61.6181 0.540039H47.5595V17.3981H51.6817V11.3993H60.9106C61.4028 11.4301 61.8027 11.83 61.8027 12.3222V17.4289H65.9249V12.2607C65.9249 11.3686 65.4327 10.5995 64.6944 10.1688C65.5865 9.33823 66.1403 8.13848 66.1403 6.84644V5.06219C66.171 2.57039 64.1407 0.540039 61.6181 0.540039ZM62.0488 6.84644C62.0488 7.33864 61.6489 7.76933 61.1259 7.76933H51.6817V4.17006H61.1259C61.6181 4.17006 62.0488 4.56998 62.0488 5.09295V6.84644Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3598 6.81567V11.184H37.5305V6.81567H44.3598ZM28.8861 17.3981H35.6847V13.0298H28.8861V17.3981ZM44.3598 4.20083C44.3598 2.17047 42.7294 0.540039 40.699 0.540039H37.5612V4.90837H44.3598V4.20083ZM28.8861 0.540039V4.90837H35.6847V0.540039H28.8861ZM20.2109 6.81567V11.184H27.0095V6.81567H20.2109ZM37.5305 17.3981H40.6683C42.6986 17.3981 44.3291 15.7677 44.3291 13.7373V13.0298H37.5305V17.3981ZM20.2109 13.7373C20.2109 15.7677 21.8414 17.3981 23.8717 17.3981H27.0095V13.0298H20.2109V13.7373ZM20.2109 4.20083V4.90837H27.0095V0.540039H23.8717C21.8414 0.540039 20.2109 2.17047 20.2109 4.20083Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_2890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 16.9196,
    fill: "white",
    transform: "translate(0 0.540039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard3);
export default __webpack_public_path__ + "static/media/hard3.cbb297dd8923add0eb41b1ba69d36f1b.svg";
export { ForwardRef as ReactComponent };